import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { selectRegionId } from 'shared/selectors/location';
import { fetchRegionalDistrictsByLocation } from 'shared/services/fetchRegionalDistrictsByLocation';
import { IRequestRegionalDistrictsDataPayload } from 'shared/slices/geo/types';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const loadRegionalDistricts = createAsyncThunk<IRequestRegionalDistrictsDataPayload, void, IThunkApiExtended>(
  'geo/regionalDistricts/loadData',
  async (_, { getState, extra: context, rejectWithValue }) => {
    const state = getState();
    const locationId = selectRegionId(state);

    try {
      const regionalDistricts = await fetchRegionalDistrictsByLocation(context, { locationId });

      return {
        regionalDistricts,
        regionId: locationId,
      };
    } catch (e) {
      return rejectWithValue();
    }
  },
);
